import { type TokenGroup } from "../../types";

export const cyan = {
  name: "cyan",
  variables: {
    "1": { type: "color", value: { dark: "#07191d", light: "#fafdfe" } },
    "2": { type: "color", value: { dark: "#061e24", light: "#f2fcfd" } },
    "3": { type: "color", value: { dark: "#072830", light: "#e7f9fb" } },
    "4": { type: "color", value: { dark: "#07303b", light: "#d8f3f6" } },
    "5": { type: "color", value: { dark: "#073844", light: "#c4eaef" } },
    "6": { type: "color", value: { dark: "#064150", light: "#aadee6" } },
    "7": { type: "color", value: { dark: "#045063", light: "#84cdda" } },
    "8": { type: "color", value: { dark: "#00647d", light: "#3db9cf" } },
    "9": { type: "color", value: { dark: "#05a2c2", light: "#05a2c2" } },
    "10": { type: "color", value: { dark: "#00b1cc", light: "#0894b3" } },
    "11": { type: "color", value: { dark: "#00c2d7", light: "#0c7792" } },
    "12": { type: "color", value: { dark: "#e1f8fa", light: "#04313c" } },
  },
} as const satisfies TokenGroup<"cyan">;
